import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=7019c477&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=7019c477&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7019c477",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7019c477')) {
      api.createRecord('7019c477', component.options)
    } else {
      api.reload('7019c477', component.options)
    }
    module.hot.accept("./FormComponent.vue?vue&type=template&id=7019c477&scoped=true", function () {
      api.rerender('7019c477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/loginForm/FormComponent.vue"
export default component.exports